import {Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {NzModalService} from 'ng-zorro-antd';
import {BusinessCodeService} from 'src/app/services/business/business-code/business-code.service';
import {RootService} from '../../services';
import {NzNotificationService} from 'ng-zorro-antd/notification';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-business-codes',
  templateUrl: './business-codes.component.html',
  styleUrls: ['./business-codes.component.scss']
})
export class BusinessCodesComponent implements OnInit {
  // tslint:disable-next-line:variable-name
  message_note = '';
  glnCode;
  page = 1;
  pageSize = 10;
  enterpriseCode;
  name;
  status;
  query;
  // tslint:disable-next-line:variable-name
  list_business_code = [];
  // tslint:disable-next-line:variable-name
  list_id;
  total: number;
  loading = false;
  data = new Array();
  // tslint:disable-next-line:variable-name
  select_status = [
    {label: 'Đã duyệt', value: 1},
    {label: 'Chờ duyệt', value: 2},
    {label: 'Từ chối', value: 3},
  ];
  changeAction;
  // tslint:disable-next-line:variable-name
  modal = {
    label: 'Xác nhận xóa mã doanh nghiệp',
    value: ' <p class="mrb-10">Hệ thống sẽ xóa mã doanh nghiệp này.</p>\n' +
      '          <p>Bạn có chắc chắn muốn xoá?</p>'
  };
  modal2 = {
    label: 'Xác nhận xóa nhiều mã doanh nghiệp',
    value: ' <p class="mrb-10">Hệ thống sẽ xóa những mã doanh nghiệp này.</p>\n' +
      '          <p>Bạn có chắc chắn muốn xoá?</p>'
  };
  isSpinning = false;
  // multiple checkbox
  isAllDisplayDataChecked = false;
  isIndeterminate = false;
  mapOfCheckedId = {};
  // @ts-ignore
  // tslint:disable-next-line:variable-name
  list_id = [];
  // @ts-ignore
  @ViewChild('delete') delete;

  constructor(
    private  fb: FormBuilder,
    private modalService: NzModalService,
    private codeService: BusinessCodeService,
    private notification: NzNotificationService,
    private rootService: RootService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
  }

  clearPosParam() {
    this.router.navigate(
      ['.'],
      {relativeTo: this.route}
    );
  }

  ngOnInit(): void {

    this.route.queryParams.subscribe(params => {
      if (params.gln !== undefined) {
        this.clearPosParam();
        this.enterpriseCode = params.gln;
      }
      this.getBusinessCodes();
    });
    this.changeAction = undefined;
    this.notification.config({
      nzPlacement: 'bottomRight'
    });
  }

  getBusinessCodes() {
    this.data = [];
    this.loading = true;
    this.query = {
      glnCode: this.enterpriseCode ? this.enterpriseCode.trim() : '',
      name: this.name ? this.name.trim() : '',
      page: this.page,
      page_size: this.pageSize
    };
    if (this.status) {
      this.query.status = this.status;
    }
    this.codeService.list(this.query).subscribe(
      res => {
        this.loading = false;
        if (res.code === 1) {
          if (res.data.items.length === 0 && this.page > 1) {
            this.page = this.page - 1;
            this.getBusinessCodes();
            return;
          }
          this.total = res.data.totalElement;
          this.list_business_code = res.data.items;
          this.refreshStatus();
          return;
        }
        this.notification.create(
          'error',
          'Lấy danh sách mã doanh nghiệp thất bại',
          res.message
        );
      },
      error => {
        this.loading = false;
        this.notification.create(
          'error',
          'Lấy danh sách mã doanh nghiệp thất bại',
          'Hệ thống đang nâng cấp.Vui lòng thử lại sau'
        );
      }
    );
  }

  search() {
    this.page = 1;
    this.getBusinessCodes();
  }

  reset() {
    this.page = 1;
    this.enterpriseCode = undefined;
    this.name = undefined;
    this.status = undefined;
    this.getBusinessCodes();
  }

  createGLN(event) {
    this.getBusinessCodes();
  }

  updateGLN(event) {
    this.getBusinessCodes();
  }

  deleteGLN(id) {
    const body = {
      body: {
        ids: id
      }
    };
    this.codeService.remove(body).subscribe(
      res => {
        if (res.code === 1) {
          this.notification.create(
            'success',
            'Thành công',
            'Xóa mã doanh nghiệp thành công'
          );
          this.list_id = [];
          this.mapOfCheckedId = {};
          this.delete.handleCancel();
          setTimeout(() => {
            this.getBusinessCodes();
          }, 1000);
        } else {
          this.notification.create(
            'error',
            'Xóa mã doanh nghiệp thất bại',
            res.message
          );
        }
        this.delete.success();
      },
      error => {
        this.isSpinning = false;
        this.notification.create(
          'error',
          'Xóa mã doanh nghiệp thất bại',
          'Hệ thống đang nâng cấp.Vui lòng thử lại sau'
        );
        this.delete.success();
      }
    );
  }

  // checkbox multiple
  checkAll(value: boolean) {
    this.list_business_code.forEach(item => (this.mapOfCheckedId[item.id] = value));
    if (this.data.length === this.list_business_code.length) {
      this.data = [];
      return;
    }
    this.data = this.list_business_code.map(z => {
      return {glnCode: z.glnCode, name: z.name, status: z.status};
    });

    this.refreshStatus();
  }

  refreshStatus(data ?) {

    if (data) {
      const index = this.data.findIndex(z => z.glnCode === data.glnCode);
      index === -1 ? this.data.push({glnCode: data.glnCode, status: data.status, name: data.name}) : this.data.splice(index, 1);

    }
    if (this.list_business_code.length > 0) {
      this.isAllDisplayDataChecked = this.list_business_code.every(item => this.mapOfCheckedId[item.id]);
    } else {
      this.isAllDisplayDataChecked = false;
    }
    this.isIndeterminate = this.list_business_code.some(item => this.mapOfCheckedId[item.id]) && !this.isAllDisplayDataChecked;
    for (const key in this.mapOfCheckedId) {
      if (this.mapOfCheckedId[key] === true) {
        if (!this.list_id.includes(key)) {
          this.list_id.push(key);
        }
      } else {
        if (this.list_id.includes(key)) {
          this.list_id.splice(this.list_id.indexOf(key), 1);
        }
      }
    }

  }

  multipleDeleteGLN() {
    if (this.list_id.length) {

      this.delete.showModal(this.modal2, this.list_id);
    } else {
      this.notification.create(
        'error',
        'Xóa mã doanh nghiệp thất bại',
        'Chưa chọn mã doanh nghiệp cần xóa'
      );
    }
  }

  exportGLN() {
    this.loading = true;
    this.query = {
      glnCode: this.enterpriseCode ? this.enterpriseCode.trim() : '',
      name: this.name ? this.name.trim() : '',
      // status: this.status ? this.status : '',
      page: this.page,
      page_size: this.pageSize,
      ids: this.list_id.length > 0 ? this.list_id.toString() : undefined,
      export_all: this.list_id.length === 0,
    };
    if (this.status) {
      this.query.status = this.status;
    }
    this.codeService.exportGLN(this.query).subscribe(
      res => {
        this.rootService.export(res, 'Danh sách mã doanh nghiệp.xlsx');
        this.loading = false;
        this.mapOfCheckedId = {};
        this.list_id = [];
        this.refreshStatus();
      },
      error => {
        this.notification.error(
          'Export mã doanh nghiệp thất bại',
          'Hệ thống đang nâng cấp.Vui lòng thử lại sau'
        );
        this.loading = false;
      }
    );
  }

  actionsButton(event) {
    if (event) {
      this.changeAction = event;
    }
  }

  buttonSubmit() {
    // tslint:disable-next-line:triple-equals
    if (this.changeAction == 1) {
      this.multipleDeleteGLN();
    }
    // tslint:disable-next-line:triple-equals
    if (this.changeAction == 2) {
      this.exportGLN();
    }
  }
}
